export default __webpack_public_path__ + "static/media/Animations_Circle12.b877f331.svg";